"use client";

import { createContext, useContext } from "react";

// These caller-scoped subscriptions live above route boundaries. New account
// controls can use their already-applied data without another loading cycle.
export const AccountReadinessContext = createContext(false);
export function useAccountReadiness() {
  return useContext(AccountReadinessContext);
}
